<!--用户注册组件-->
<template>
  <div id="register">
    <el-dialog title="注册" width="300px" center :visible.sync="isRegister">
      <el-form
        :model="RegisterUser"
        :rules="rules"
        status-icon
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item prop="name">
          <el-input
            prefix-icon="el-icon-user-solid"
            placeholder="请输入账号"
            v-model="RegisterUser.name"
          ></el-input>
        </el-form-item>

        <el-form-item prop="code">
          <el-input
            prefix-icon="el-icon-user-solid"
            placeholder="请输入验证码"
            v-model="RegisterUser.code"
          >
            <el-button type="primary" plain slot="suffix" @click="sendMsg" :disabled="isDisabled">{{ buttonName }}
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item prop="pass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            placeholder="请输入密码"
            v-model="RegisterUser.pass"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            placeholder="请再次输入密码"
            v-model="RegisterUser.confirmPass"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="Register" style="width:100%;">注册</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MyRegister',
  props: ['register'],
  data () {
    // 用户名的校验方法
    let validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      }
      // 用户名以字母开头,长度在5-16之间,允许字母数字下划线
      const userNameRule = /^1[3|4|5|8][0-9]\d{4,8}$/
      if (userNameRule.test(value)) {
        // 判断数据库中是否已经存在该用户名
        this.$axios.get('/vueback/user/getUserByPhone', {params: {phone: this.RegisterUser.name}})
          .then(res => {
            // “001”代表用户名不存在，可以注册
            if (res.data.code === 20000) {
              this.$refs.ruleForm.validateField('checkPass')
              return callback()
            } else {
              return callback(new Error(res.data.data.msg))
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      } else {
        return callback(new Error('请输入正确的手机号码'))
      }
    }
    // 验证码验证方法
    let validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入六位验证码'))
      }
      // 用户名以字母开头,长度在5-16之间,允许字母数字下划线
      const codeRule = /^\d{6}$/
      console.log('验证方法')
      console.log(this.RegisterUser.code)
      console.log(this.RegisterUser.name)
      if (codeRule.test(value)) {
        // 判断redis数据库中是否已经存在该code
        this.$axios.get(`/vueback/user/msm/getCode/${this.RegisterUser.name}`)
          .then(res => {
            console.log('从redis获取的验证码是：' + res.data.code)
            if (res.data.code !== null) {
              this.$refs.ruleForm.validateField('checkPass')
              return callback()
            } else {
              return callback(new Error())
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      } else {
        return callback(new Error('请输入正确的验证码'))
      }
    }
    // 密码的校验方法
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入密码'))
      }
      // 密码以字母开头,长度在6-18之间,允许字母数字和下划线
      const passwordRule = /^[a-zA-Z]\w{5,17}$/
      if (passwordRule.test(value)) {
        this.$refs.ruleForm.validateField('checkPass')
        return callback()
      } else {
        return callback(
          new Error('字母开头,长度6-18之间,允许字母数字和下划线')
        )
      }
    }
    // 确认密码的校验方法
    let validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入确认密码'))
      }
      // 校验是否以密码一致
      if (this.RegisterUser.pass !== '' && value === this.RegisterUser.pass) {
        this.$refs.ruleForm.validateField('checkPass')
        return callback()
      } else {
        return callback(new Error('两次输入的密码不一致'))
      }
    }
    return {
      isRegister: false, // 控制注册组件是否显示
      buttonName: '获取验证码',
      isDisabled: false,
      time: 120,
      RegisterUser: {
        name: '',
        code: '',
        pass: '',
        confirmPass: ''
      },
      // 用户信息校验规则,validator(校验方法),trigger(触发方式),blur为在组件 Input 失去焦点时触发
      rules: {
        name: [{validator: validateName, trigger: 'blur'}],
        code: [{validator: validateCode, trigger: 'blur'}],
        pass: [{validator: validatePass, trigger: 'blur'}],
        confirmPass: [{validator: validateConfirmPass, trigger: 'blur'}]
      }
    }
  },
  watch: {
    // 监听父组件传过来的register变量，设置this.isRegister的值
    register: function (val) {
      if (val) {
        this.isRegister = val
      }
    },
    // 监听this.isRegister变量的值，更新父组件register变量的值
    isRegister: function (val) {
      if (!val) {
        this.$refs['ruleForm'].resetFields()
        this.$emit('fromChild', val)
      }
    }
  },
  methods: {
    Register () {
      // 通过element自定义表单校验规则，校验用户输入的用户信息
      this.$refs['ruleForm'].validate(valid => {
        // 如果通过校验开始注册
        if (valid) {
          this.$axios.get('/vueback/user/userRegister', {params: {
            phone: this.RegisterUser.name,
            password: this.RegisterUser.pass}
          })
            .then(res => {
              // “001”代表注册成功，其他的均为失败
              if (res.data.code === 20000) {
                // 隐藏注册组件
                this.isRegister = false
                // 弹出通知框提示注册成功信息
                this.notifySucceed(res.data.data.msg)
              } else {
                // 弹出通知框提示注册失败信息
                this.notifyError(res.data.data.msg)
              }
            })
            .catch(err => {
              return Promise.reject(err)
            })
        } else {
          return false
        }
      })
    },
    sendMsmCode () {
      this.$axios.get(`/vueback/user/msm/send/${this.RegisterUser.name}`)
        .then(res => {
          // “001”代表code存在，可以注册
          console.log('发送验证码的手机号码' + this.RegisterUser.name)
          if (res.data.isSuccess !== null) {
            console.log('发送的验证码是：' + res.data.isSuccess)
            this.$refs.ruleForm.validateField('checkPass')
          } else {
            console.log('发送验证码失败了666')
          }
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    sendMsg () {
      this.sendMsmCode()
      let me = this
      me.isDisabled = true
      let interval = window.setInterval(function () {
        me.buttonName = '(' + me.time + 's)后重新发送'
        --me.time
        if (me.time < 0) {
          me.buttonName = '重新发送'
          me.time = 10
          me.isDisabled = false
          window.clearInterval(interval)
        }
      }, 1000)
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MyRegister.vue